export default function cookieDomain() {
  return window.TC.Config.cookie_domain;
}
